import { MARKS as M } from '@contentful/rich-text-types'
import { Options } from '@uswitch/ev-components/lib/components/defaults/options'

import Badge from '../badge'

const shallowMerge = (a, b) => ({
  renderMark: { ...a.renderMark, ...b.renderMark },
  renderNode: { ...a.renderNode, ...b.renderNode }
})

const BBOptions = {
  renderMark: {
    [M.UNDERLINE]: Badge
  }
}

const MergedOptions = Options({ optionOverrides: BBOptions })

export default ({ optionOverrides = {} } = {}) => shallowMerge(MergedOptions, optionOverrides)
